export const ACCESS_TOKEN_KEY = 'nvr.auth.accessToken';
export const REFRESH_TOKEN_KEY = 'nvr.auth.refreshToken';

export function getStoredAccessToken(): string | null {
  try {
    const value = window.localStorage.getItem(ACCESS_TOKEN_KEY);
    return value && value.trim().length > 0 ? value : null;
  } catch {
    return null;
  }
}

export function getStoredRefreshToken(): string | null {
  try {
    const value = window.localStorage.getItem(REFRESH_TOKEN_KEY);
    return value && value.trim().length > 0 ? value : null;
  } catch {
    return null;
  }
}

/** Headers for `fetch` / WHEP (not covered by axios interceptors). */
export function authHeaders(extra?: Record<string, string>): HeadersInit {
  const headers: Record<string, string> = { ...extra };
  const token = getStoredAccessToken();
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
}

/**
 * Appends JWT for `<video src>` and Safari native HLS where headers are unavailable.
 * Backend `authenticateJwt` accepts `access_token` query param as a fallback.
 */
export function withAccessToken(url: string): string {
  const token = getStoredAccessToken();
  if (!token) return url;
  try {
    const parsed = new URL(url, window.location.origin);
    if (!parsed.searchParams.has('access_token')) {
      parsed.searchParams.set('access_token', token);
    }
    return parsed.toString();
  } catch {
    const sep = url.includes('?') ? '&' : '?';
    return `${url}${sep}access_token=${encodeURIComponent(token)}`;
  }
}
